// Browser voice input abstraction — Web Speech API (Phase 1).
// The rest of the application only ever calls startListening() and stopListening().
// To upgrade to Google Cloud Speech-to-Text (Phase 3): change only this file.

export class VoiceInput {
  constructor(onTranscript, onError) {
    this._onTranscript = onTranscript;
    this._onError = onError;
    this._recognition = null;
  }

  isSupported() {
    try {
      return 'webkitSpeechRecognition' in window || 'SpeechRecognition' in window;
    } catch {
      return false;
    }
  }

  startListening() {
    if (!this.isSupported()) {
      this._onError(new Error('Speech recognition is not supported in this browser. Please use Chrome or Edge.'));
      return;
    }

    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    this._recognition = new SpeechRecognition();

    this._recognition.lang            = 'en-GB';
    this._recognition.continuous      = false;   // one utterance per activation
    this._recognition.interimResults  = false;   // final result only
    this._recognition.maxAlternatives = 1;

    this._recognition.onresult = (event) => {
      const transcript = event.results[0][0].transcript;
      this._onTranscript(transcript);
    };

    this._recognition.onerror = (event) => {
      this._onError(new Error(event.error || 'Speech recognition error'));
    };

    // Microphone released automatically when recognition ends (VOICE-02)
    this._recognition.onend = () => {
      this._recognition = null;
    };

    this._recognition.start();
  }

  stopListening() {
    if (this._recognition) {
      try {
        this._recognition.stop();
      } catch {
        // already stopped — safe to ignore
      }
      this._recognition = null;
    }
  }
}
